import React from "react";
import { Flex } from "../../../Flex";
import { Span } from "../../../Span";
import { Box } from "../../../Box";
import { DisconnectionDetailsFileUpload } from "../DisconnectionDetailsFileUpload";
import { IconPopupTip } from "../../../IconPopupTip";

interface Props {
  id: string;
}

export const DisconnectionUploadPhotosForm: React.FC<Props> = ({ id }) => {
  return (
    <Box id={id}>
      <Flex>
        <Span
          display="inline-block"
          fontSize={4}
          lineHeight={4}
          fontWeight="medium"
        >
          Upload Photos
        </Span>
        <IconPopupTip icon="help" ml={["auto", "auto", "auto", 3]}>
          {
            "Providing photos of the electricity meter will help us ensure the correct property is permanently disconnected"
          }
        </IconPopupTip>
        <Span color={"neutrals.mn60"} ml={3} fontSize={1} lineHeight={4} mr={3}>
          Optional
        </Span>
      </Flex>

      <Flex mt={4} mb={1} flexDirection="column">
        <DisconnectionDetailsFileUpload
          id={`${id}-disconnection-file-upload`}
        />
      </Flex>
    </Box>
  );
};
